(function () {
  'use strict';

  var Utils = window.TDCUtils;
  var root = document.documentElement;

  var searchInput = document.getElementById('search-input');
  var resultsEl = document.getElementById('results');
  var resultsTitle = document.getElementById('results-title');
  var searchEmpty = document.getElementById('search-empty');
  var searchColsEl = document.getElementById('search-collections');
  var searchDebounce = null;

  /* Always use .json endpoint — routes.predictive_search_url may omit it */
  var predictiveUrl = '/search/suggest.json';

  function buildSearchUrl(q) {
    /* Build manually — URLSearchParams encodes [] as %5B%5D which Shopify rejects */
    return predictiveUrl +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=16' +
      '&resources[options][unavailable_products]=last';
  }

  function renderSearchResults(data, q) {
    if (!resultsEl) return;
    var resources = (data && data.resources && data.resources.results) ? data.resources.results : {};
    var products = resources.products || [];
    var collections = resources.collections || [];

    if (searchColsEl) {
      if (collections.length > 0) {
        searchColsEl.innerHTML = collections.slice(0, 6).map(function (c) {
          return '<li><a href="' + Utils.esc(c.url) + '" data-close>' + Utils.highlight(c.title, q) +
            (c.products_count != null ? ' <span class="n">' + c.products_count + '</span>' : '') +
            '</a></li>';
        }).join('');
      } else {
        searchColsEl.innerHTML = '';
      }
    }

    if (resultsTitle) {
      if (q) {
        resultsTitle.textContent = products.length + (products.length === 1 ? ' piece' : ' pieces') + ' for "' + q + '"';
      }
    }

    if (products.length > 0) {
      resultsEl.innerHTML = products.slice(0, 16).map(function (p) {
        var imgRaw = p.featured_image ? (p.featured_image.url || p.featured_image) : (p.image || '');
        var img = imgRaw ? Utils.resizeImageUrl(String(imgRaw), 200) : '';
        var price = p.price ? Utils.formatMoney(p.price) : '';
        var comparePrice = (p.compare_at_price && p.compare_at_price > p.price) ? Utils.formatMoney(p.compare_at_price) : '';
        return '<a class="result" href="' + Utils.esc(p.url) + '" data-close>' +
          (img ? '<div class="frame product"><img src="' + Utils.esc(img) + '" alt="' + Utils.esc(p.title) + '" loading="lazy" width="100" height="120"></div>' : '') +
          '<strong>' + Utils.highlight(p.title, q) + '</strong>' +
          '<span>' + (comparePrice ? '' + comparePrice + ' ' : '') + price + '</span>' +
          '</a>';
      }).join('');
      if (searchEmpty) searchEmpty.hidden = true;
    } else {
      resultsEl.innerHTML = '';
      if (searchEmpty) {
        searchEmpty.hidden = false;
        searchEmpty.textContent = q
          ? 'No pieces match "' + q + '". Try browsing our collections.'
          : 'Start typing to search our collection.';
      }
    }
  }

  var initialResultsHtml = resultsEl ? resultsEl.innerHTML : '';
  var initialColsHtml = searchColsEl ? searchColsEl.innerHTML : '';
  var initialTitle = resultsTitle ? resultsTitle.textContent : 'Trending now';

  function renderSearch(raw) {
    if (!resultsEl) return;
    var q = (raw || '').trim();

    clearTimeout(searchDebounce);

    /* Empty query — restore initial trending pieces and collections */
    if (!q) {
      if (resultsEl) resultsEl.innerHTML = initialResultsHtml;
      if (searchColsEl) searchColsEl.innerHTML = initialColsHtml;
      if (searchEmpty) searchEmpty.hidden = true;
      if (resultsTitle) resultsTitle.textContent = initialTitle;
      return;
    }

    searchDebounce = setTimeout(function () {
      var url = buildSearchUrl(q);
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Search API error ' + res.status);
          return res.json();
        })
        .then(function (data) {
          renderSearchResults(data, q);
        })
        .catch(function (err) {
          console.warn('[TDC Search] Predictive search failed:', err.message);
          if (resultsEl) resultsEl.innerHTML = '';
          if (searchEmpty) {
            searchEmpty.hidden = false;
            searchEmpty.textContent = 'Search unavailable. Please try again.';
          }
        });
    }, 220);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () { renderSearch(searchInput.value); });
  }

  document.querySelectorAll('.chip').forEach(function (c) {
    c.addEventListener('click', function () {
      if (searchInput) {
        searchInput.value = c.textContent.trim();
        renderSearch(searchInput.value);
        searchInput.focus();
      }
    });
  });

  window.TDCSearch = {
    render: renderSearch,
    buildUrl: buildSearchUrl
  };
})();